import { DropdownContainer, OptionsList } from 'components/list';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as moment from 'moment';
import * as React from 'react';

// Styles
const s = require('./SelectTime.css');

// Interfaces
export interface ITimeValue {
    hours: number;
    minutes: number;
    totalMinutes: number;
}

interface ITimeOptions {
    label: string;
    value: ITimeValue;
}

// Props
interface ISelectTimeProps {
    onChange?:
        | (({ value, label }: { value: ITimeValue; label: string }) => void)
        | null;
    value?: ITimeValue | null;
    label?: string | null;
    formatting?: '24' | '12' | 24 | 12 | null;
}

// Component
@observer
export class SelectTime extends React.Component<ISelectTimeProps, {}> {
    static get defaultProps(): ISelectTimeProps {
        const now = new Date();

        return {
            onChange: null,
            value: {
                hours: now.getHours(),
                minutes: now.getMinutes(),
                totalMinutes: now.getHours() * 60 + now.getMinutes(),
            },
            label: 'Time',
            formatting: 12,
        };
    }

    constructor(props: ISelectTimeProps) {
        super(props);
    }

    @computed private get isAmerican(): boolean {
        const formatting =
            typeof this.props.formatting === 'string'
                ? parseInt(this.props.formatting, 10)
                : this.props.formatting;
        return 12 ? true : false;
    }

    @computed private get options(): ITimeOptions[] {
        const result: ITimeOptions[] = [];

        const everyMinutes: number = 15;

        let addedNow: number = 0;
        const nowTotalMinutes = this.props.value
            ? this.props.value.totalMinutes
            : moment().hours() * 60 + moment().minutes();

        let totalMinutes = 420;
        const maxTotalMinutes = 1160;
        while (totalMinutes <= maxTotalMinutes) {
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes - hours * 60;
            result.push({
                value: {
                    hours,
                    minutes,
                    totalMinutes,
                },
                label: this.getLabel(hours, minutes),
            });
            totalMinutes = totalMinutes + everyMinutes;

            if (
                addedNow === 0 &&
                (totalMinutes > nowTotalMinutes ||
                    (totalMinutes >= maxTotalMinutes &&
                        nowTotalMinutes > maxTotalMinutes))
            ) {
                if (nowTotalMinutes % everyMinutes > 0) {
                    const nowHours = Math.floor(nowTotalMinutes / 60);
                    const nowMinutes = nowTotalMinutes - nowHours * 60;
                    result.push({
                        value: {
                            hours: nowHours,
                            minutes: nowMinutes,
                            totalMinutes: nowTotalMinutes,
                        },
                        label: this.getLabel(nowHours, nowMinutes),
                    });
                    addedNow++;
                }
            }
        }

        return result;
    }

    public render() {
        return (
            <DropdownContainer
                ref={this.referenceDropdown}
                maxHeight={400}
                label={this.props.label || null}
                value={
                    this.props.value
                        ? this.getLabel(
                              this.props.value.hours,
                              this.props.value.minutes
                          )
                        : undefined
                }
            >
                <OptionsList
                    onChange={this.handleValueChange}
                    options={this.options}
                    label="Pick time"
                    value={this.props.value}
                />
            </DropdownContainer>
        );
    }

    private dropdown: DropdownContainer = null;
    private referenceDropdown = (ref: DropdownContainer) =>
        (this.dropdown = ref);

    private handleValueChange = (changed: {
        value: ITimeValue;
        label: string;
    }) => {
        if (this.props.onChange) {
            this.props.onChange(changed);
        }

        if (this.dropdown) {
            this.dropdown.closeDropdown();
        }
    };

    private getLabel = (hours: number, minutes: number): string => {
        const now = moment();
        now.hours(hours);
        now.minutes(minutes);

        return this.isAmerican ? now.format('hh:mm A') : now.format('HH:mm');
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/calendar/SelectTime.tsx